// import Users from './components/Users';
// import Logout from './components/Logout';
// import { Container } from 'react-bootstrap';

// Main App component serving as the entry point
// Imports various components and handles routing, authentication, and layout
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import Signin from './components/Signin';
import Signup from './components/Signup';
import Clothes from './components/Clothes';
import Outfits from './components/Outfits';
import CreateOutfit from './components/CreateOutfit';
import EditOutfit from './components/EditOutfit';
import Occasions from './components/Occasions';
import CreateOccasion from './components/CreateOccasion';
import EditOccasion from './components/EditOccasion';
import TravelLists from './components/TravelLists';
import CreateTravelList from './components/CreateTravelList';
import EditTravelList from './components/EditTravelList';
import UploadCloth from './components/UploadCloth';
import EditCloth from './components/EditCloth';
import MyAccount from './components/MyAccount';
import MyAccountEdit from './components/MyAccountEdit';
import AboutUs from './components/AboutUs';
import OurServices from './components/OurServices';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsandConditions from './components/TermsandConditions';
import UserAgreement from './components/UserAgreement';
import HowItWorks from './components/HowItWorks';
import HelpCenter from './components/HelpCenter';
import FAQ from './components/FAQ';
import ContactUs from './components/ContactUs';
import './App.css';

const App = () => {
    // State variables for tracking authentication status and token
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [token, setToken] = useState(localStorage.getItem('token') || '');

    // Update sign-in status if token is present in localStorage on initial load
    useEffect(() => {
        if (token) {
            setIsSignedIn(true);
        }
    }, [token]);

    // Handle user sign-in, storing token in localStorage
    const handleSignIn = (accessToken) => {
        setIsSignedIn(true);
        setToken(accessToken);
        localStorage.setItem('token', accessToken);
    };

    // Handle user sign-out, clearing token from localStorage
    const handleSignOut = () => {
        setIsSignedIn(false);
        setToken('');
        localStorage.removeItem('token');
    };

    return (
        <Router>
            <div className="wrapper">            
                <Header isSignedIn={isSignedIn} handleSignOut={handleSignOut} />
                <div className="content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/signin" element={<Signin onSignIn={handleSignIn} />} />
                        <Route path="/about-us" element={<AboutUs />} />
                        <Route path="/our-services" element={<OurServices />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-and-conditions" element={<TermsandConditions />} />
                        <Route path="/user-agreement" element={<UserAgreement />} />
                        <Route path="/how-it-works" element={<HowItWorks />} />
                        <Route path="/help-center" element={<HelpCenter />} />
                        <Route path="/frequently-asked-questions" element={<FAQ />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                        {isSignedIn && <Route path="/clothes" element={<Clothes />} />}
                        {isSignedIn && <Route path="/outfits" element={<Outfits />} />}
                        {isSignedIn && <Route path="/occasions" element={<Occasions />} />}
                        {isSignedIn && <Route path="/travellists" element={<TravelLists />} />}
                        {isSignedIn && <Route path="/upload" element={<UploadCloth />} />}
                        {isSignedIn && <Route path="/create-outfit" element={<CreateOutfit />} />}
                        {isSignedIn && <Route path="/create-occasion" element={<CreateOccasion />} />}
                        {isSignedIn && <Route path="/create-travellist" element={<CreateTravelList />} />}
                        {isSignedIn && <Route path="/edit-occasion/:id" element={<EditOccasion />} />}
                        {isSignedIn && <Route path="/edit-cloth/:id" element={<EditCloth />} />}
                        {isSignedIn && <Route path="/edit-outfit/:id" element={<EditOutfit />} />}
                        {isSignedIn && <Route path="/edit-travellist/:id" element={<EditTravelList />} />}
                        {isSignedIn && <Route path="/my-account" element={<MyAccount setIsSignedIn={setIsSignedIn} />} />}
                        {isSignedIn && <Route path="/edit-my-account" element={<MyAccountEdit />} />}
                        {!isSignedIn && <Route path="*" element={<Signin onSignIn={handleSignIn} />} />}
                    </Routes>
                </div>
                <Footer />
            </div>
        </Router>
    );
};

export default App;